<main class="app-content">
    <router-outlet />
</main>
<app-footer />
